// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".num-wrapper .el-slider__runway.show-input {\n  width: 95px;\n}\n.num-wrapper .el-input-number--mini {\n  line-height: 28px;\n}\n.num-wrapper .el-slider__button {\n  width: 12px;\n  height: 12px;\n  background: #2877FF;\n}\n.num-wrapper .el-slider__input {\n  width: 92px;\n}\n.num-wrapper .el-input__inner {\n  padding: 0;\n  color: #2877FF;\n}\n", ""]);
// Exports
module.exports = exports;
